<script lang="ts">
  import ActionButton from '../components/ActionButton.svelte';
  import Delta from '~icons/mdi/delta';
  import { onMount } from 'svelte';
  import {
    CHANGELOG_VERSION,
    changelogVersion,
    changelogViewed,
  } from './state.svelte';
  import { changelogModal } from '~/modals/ChangelogModal.svelte';

  onMount(() => {
    // don't show changelog to first-time players
    if (!changelogVersion.current) {
      changelogVersion.current = CHANGELOG_VERSION;
    }
    if (!changelogViewed.current) {
      handleOpen();
    }
  });

  export const handleOpen = async () => {
    await changelogModal.push();
  };
</script>

<ActionButton onClick={handleOpen} buttonId="changelog">
  <Delta color="#4CAF50" size="1.5em" />
  Updates
</ActionButton>
